<template>
  <section role="main" class="content-body">
    <header class="page-header">
      <h2>信件通知</h2>
      <div class="right-wrapper">
        <ol class="breadcrumbs">
          <li>
            <a href="/">
              <i class="fa fa-home"></i>
            </a>
          </li>
          <li><span>信件通知</span></li>
        </ol>
      </div>
    </header>
    <!-- start: page -->
    <div id="tabs-02" class="row">
      <div id="tabs-04" class="row">
        <div class="col-md-12">
          <section class="panel">
            <div class="panel-body">
              <div class="form-group">
                <label class="col-sm-2">發信日期<span class="required">*</span>：</label>
                <div class="col-sm-9">
                  <datepicker :format="customFormatter" :language="zh" v-model="mailDate" :style="{width:'20%'}" />
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-2 ">收件人<span class="required">*</span>：</label>
                <div class="col-sm-9">
                  <div class="radio-custom radio-primary">
                    <input id="type_1" type="radio" value="安全股長" v-model="form.type" />
                    <label for="type_1">安全股長</label>
                  </div>
                  <div class="radio-custom radio-primary">
                    <input id="type_2" type="radio" value="導師及系輔導員" v-model="form.type" />
                    <label for="type_2">導師及系輔導員</label>
                  </div>
                  <div class="radio-custom radio-primary">
                    <input id="type_3" type="radio" value="校安輔導人員" v-model="form.type" />
                    <label for="type_3">校安輔導人員</label>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-2">主　旨<span class="required">*</span>：</label>
                <div class="col-sm-9">
                  <input type="text" style="width: 98%;" v-model="form.title" />
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-2 control-label">內　容<span class="required">*</span>：</label>
                <div class="col-sm-9">
                  <ckeditor v-model="form.content" :config="editorConfig"></ckeditor>
                </div>
              </div>
              <table width="100%" style="margin:6px;">
    import CKEditor from "@/ckeditor4";
                  <td align="right"><a href="#" @click.prevent="formClear" class="btn-upload btn" style="background-color:#666; border-color:#999; color:#FFF;">重　　填</a>　</td>
                  <td align="left"><a href="#" @click.prevent="formSubmit" class="btn-upload btn" style="background-color:#337AB7; border-color:#2E6DA4; color:#FFF;">送　　出</a></td>
                </tr>
              </table>
            </div>
          </section>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import CKEditor from "@/ckeditor4";
export default {
  data() {
    return {
      editorConfig: {
        extraPlugins: "colorbutton",
        toolbar: [
          ["Source"],
          ["Cut", "Copy", "Paste", "PasteText", "PasteFromWord"],
          ["Undo", "Redo"],
          ["RemoveFormat"],
          ["NumberedList", "BulletedList"],
          ["Outdent", "Indent"],
          ["Blockquote"],
          ["Link", "Unlink", "Anchor"],
          ["Table", "HorizontalRule"],
          ["SpecialChar"],
          "/",
          ["Styles", "Format"],
          ["Bold", "Italic", "Strike"],
          ["TextColor", "BGColor"],
          ["Maximize"],
          ["About"]
        ]
      },
      mailDate: null,
      form: {
        type: "",
        title: "",
        content: "",
        schYearTerm: 0
      }
    };
  },
  components: {
    ckeditor: CKEditor.component
  },
  computed: {
    formType() {
      return this.form.type;
    }
  },
  methods: {
    setContent() {
      if (!this.mailDate || !this.form.type) return;
      let schYear = this.mailDate.getFullYear() - 1911;
      let schTerm = 1;
      let month = this.mailDate.getMonth() + 1;
      if (month < 8) {
        schYear = schYear - 1;
        if (month > 1) {
          schTerm = 2;
        }
      }
      this.form.schYearTerm = schYear * 10 + schTerm;
      if (this.form.type == "安全股長") {
        this.form.content =
          "安全股長你好：<br />請協助修訂" +
          schYear +
          "學年第" +
          this.transformWeekday(schTerm) +
          "學期，班上校外租屋同學賃居資料。<br />請於 " +
          (this.mailDate.getFullYear() - 1911) +
          " 年 " +
          (this.mailDate.getMonth() + 1) +
          " 月 " +
          this.mailDate.getDate() +
          " 日（星期" +
          this.transformWeekday(this.mailDate.getDay()) +
          "）前至學生生活輔導系統(網址)彙整完成。";
      } else {
        this.form.content =
          this.form.type +
          "您好：<br />學生事務處煩請導師/系輔導員百忙之中，抽空協助進行賃居學生訪視及學生生活輔導，在此向各位導師致上最深深的感謝。<br /><br />" +
          "協助賃居學生輔導內容如下：<br />" +
          "一、請導師依個人及學生時間，以實地訪視、面談訪視方式擇一實施，如學生租屋處無更改且已實地訪視煩請師長關心學生生活狀況，並填寫表格內的總評部份。<br />" +
          "二、導師針對賃居學生實施處所輔導訪視，請於 000 年 00 月 00 日。<br />" +
          "三、2 人以上同學同住，於系統填寫訪視表建立乙份即可。<br />" +
          "四、師長請至學生生活輔導系統線上填寫訪視內容。<br /><br />" +
          schYear +
          "學年第" +
          this.transformWeekday(schTerm) +
          "學期賃居學生資料學生事務處生活輔導組已彙整完畢（名冊請師長於學生生活輔導系統查詢），除上述輔導訪視外，本組將針對有疑問之租屋處進行學生居家安全實地訪視。<br />" +
          "再次謝謝您的支持與配合！<br /><br />" +
          "　　敬祝<br />教安<br />" +
          "　　　學生事務處生活輔導組敬上 " +
          (this.mailDate.getFullYear() - 1911) +
          " 年 " +
          (this.mailDate.getMonth() + 1) +
          " 月 " +
          this.mailDate.getDate() +
          " 日";
      }
    },
    transformWeekday(v) {
      switch (v) {
        case 0:
          return "日";
        case 1:
          return "一";
        case 2:
          return "二";
        case 3:
          return "三";
        case 4:
          return "四";
        case 5:
          return "五";
        case 6:
          return "六";
        default:
          return "";
      }
    },
    formClear() {
      this.mailDate = null;
      this.form.type = null;
      this.form.title = null;
      this.form.content = null;
    },
    formSubmit() {
      if (this.checkForm() == false) return;
      this.$http.post("/api/shared/sendTenancyMail", this.form).then(a => {
        if (a.body.status) {
          alert("信件發送完成");
          this.formClear();
        } else {
          alert(a.body.msg);
          console.log(a.body.exstr);
        }
      });
    },
    checkForm() {
      let msg = "";
      if (!this.mailDate) msg += "『發信日期』、";
      if (this.form.type == "") msg += "『收件人』、";
      if (this.form.title == "") msg += "『主旨』、";
      if (this.form.content == "") msg += "『內容』、";
      if (msg != "") {
        alert(msg.substr(0, msg.length - 1) + " 尚未填寫");
        return false;
      }
      return true;
    }
  },
  watch: {
    mailDate() {
      this.setContent();
    },
    formType() {
      this.setContent();
    }
  }
};
</script>

<style>
.ck-content {
  height: 300px;
}
</style>